import { useContext } from "react";
import { Grid2 as Grid, Typography, Stack, Button } from "@mui/material";
import { AppContext } from "../App";
import { MODALITIES } from "../constants/values";

export function ProviderModalities() {
  const { form, updateForm } = useContext(AppContext);

  const handleSubmit = (value: string) => {
    updateForm({ providerModalities: value });
  };

  return (
    <Stack spacing={2} alignItems="center">
      <Typography variant="h6" gutterBottom>
        My provider must offer the following modality:
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        Please select one.
      </Typography>

      <Grid container spacing={2} columns={{ xs: 1, sm: 2, lg: 3 }} alignItems="stretch" justifyContent="center">
        {MODALITIES.map((value: string) => (
          <Grid size={1} key={value}>
            <Button
              fullWidth
              variant={form.providerModalities === value ? "contained" : "outlined"}
              onClick={() => handleSubmit(value)}
              sx={{
                height: "100%",
                minHeight: "48px",
                whiteSpace: "normal",
                lineHeight: 1.2,
              }}
            >
              <Typography className="button-label" variant="body1">
                {value}
              </Typography>
            </Button>
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
}
